import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

type OrganizationCompanySaveActionsProps = {
  saveLabel: string
  isSaving: boolean
  isSaveDisabled: boolean
  saveDisabledHint?: string
  onSave: () => void
}

export function OrganizationCompanySaveActions({
  saveLabel,
  isSaving,
  isSaveDisabled,
  saveDisabledHint,
  onSave,
}: OrganizationCompanySaveActionsProps) {
  const showHint = isSaveDisabled && !isSaving && Boolean(saveDisabledHint)

  return (
    <div className="flex flex-col items-end gap-2 pt-2">
      {showHint && (
        <p className="max-w-md text-end text-sm text-muted-foreground">{saveDisabledHint}</p>
      )}
      <Button
        type="button"
        className="inline-flex min-w-48 items-center justify-center"
        onClick={onSave}
        disabled={isSaving || isSaveDisabled}
      >
        {isSaving ? (
          <>
            <Loader2 className="me-2 size-4 animate-spin" />
            {saveLabel}
          </>
        ) : (
          saveLabel
        )}
      </Button>
    </div>
  )
}
